import { lazy, Suspense as ReactSuspense } from "react";
import LoadingScreen from "../components/LoadingScreen";

const Suspense: any = ReactSuspense;

const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const RouteLazyLoader = {
  // AUTHENTICATION ROUTES
  Login: Loadable(lazy(() => import("../pages/Authentication/Login/Login"))),

  // DASHBOARD ROUTES
  DashboardSaaS: Loadable(lazy(() => import("../pages/Dashboard/SaaS"))),

  // ACCOUNT / PROFILE
  AccountProfile: Loadable(
    lazy(() => import("../pages/Account/AdminProfile"))
  ),

  // INSTITUTION ADMIN ROUTES
  Investment: Loadable(
    lazy(() => import("../pages/Investments/Investments"))
  ),

  // LOAN MANAGEMENT
  Loan: Loadable(lazy(() => import("../pages/Loans/Loans"))),
  LoanForm: Loadable(lazy(() => import("../pages/Loans/LoanForm"))),
  LoanDetailView: Loadable(lazy(() => import("../pages/Loans/LoanDetail"))),

  // FINANCE — TRANSACTIONS
  AdminTransactions: Loadable(
    lazy(() => import("../pages/Transactions/AdminTransactions"))
  ),

  // FINANCE — WALLETS
  AdminWallets: Loadable(
    lazy(() => import("../pages/Wallets/AdminWallets"))
  ),

  // FINANCE — BANKS
  AdminBanks: Loadable(
    lazy(() => import("../pages/Banks/AdminBanks"))
  ),

  // FINANCE — REPORTS
  AdminReports: Loadable(
    lazy(() => import("../pages/Reports/AdminReports"))
  ),

  // ADMIN — BUSINESS PROFILES
  AdminBusiness: Loadable(
    lazy(() => import("../pages/Business/AdminBusiness"))
  ),

  // ADMIN — ACTIVITY LOG
  AdminActivity: Loadable(
    lazy(() => import("../pages/Activity/AdminActivity"))
  ),

  // ADMIN — NOTIFICATIONS
  AdminNotifications: Loadable(
    lazy(() => import("../pages/Notifications/AdminNotifications"))
  ),

  // ADMIN — PLATFORM SETTINGS
  AdminPlatformSettings: Loadable(
    lazy(() => import("../pages/PlatformSettings/AdminPlatformSettings"))
  ),

  // USERS
  Users: Loadable(lazy(() => import("../pages/AdminUsers/AdminUsers"))),
  AdminUserDetail: Loadable(
    lazy(() => import("../pages/AdminUsers/AdminUserDetail"))
  ),
  AdminProfile: Loadable(
    lazy(() => import("../pages/AdminUsers/AdminProfile"))
  ),
  DeletionRequests: Loadable(
    lazy(() => import("../pages/AdminUsers/DeletionRequests"))
  ),

  // DEVICES
  DeviceCatalog: Loadable(
    lazy(() => import("../pages/Devices/DeviceCatalog"))
  ),
  DeviceDetail: Loadable(lazy(() => import("../pages/Devices/DeviceDetail"))),
  DeviceOrders: Loadable(lazy(() => import("../pages/Devices/DeviceOrders"))),

  // ================================================================
  // Phase 6: Manual Transactions
  // ================================================================
  ManualDisbursements: Loadable(
    lazy(() => import("../pages/ManualTransactions/ManualDisbursements"))
  ),
  ManualRepayments: Loadable(
    lazy(() => import("../pages/ManualTransactions/ManualRepayments"))
  ),
  CompanyAccounts: Loadable(
    lazy(() => import("../pages/ManualTransactions/CompanyAccounts"))
  ),
  Reconciliation: Loadable(
    lazy(() => import("../pages/ManualTransactions/Reconciliation"))
  ),
  AdminManualDeposits: Loadable(
    lazy(() => import("../pages/ManualTransactions/AdminManualDeposits"))
  ),
  AdminManualWithdrawals: Loadable(
    lazy(() => import("../pages/ManualTransactions/AdminManualWithdrawals"))
  ),

  // AutoInvest treasury
  AdminAutoInvest: Loadable(
    lazy(() => import("../pages/AutoInvest/AdminAutoInvest"))
  ),

  // Recovery — defaulted loans + bad-debt collections
  AdminRecovery: Loadable(
    lazy(() => import("../pages/Recovery/AdminRecovery"))
  ),

  // ERROR ROUTES
  Error404: Loadable(lazy(() => import("../pages/404"))),
  Error403: Loadable(lazy(() => import("../pages/403"))),
};

export default RouteLazyLoader;